import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Allows only authenticated console admins (`app_metadata.console_admin`).
 * Commerce customers are signed out and sent to login.
 *
 * @returns `true`, or a UrlTree to login / update-password.
 */
export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.waitUntilReady();

  if (auth.isPasswordRecovery()) {
    return router.createUrlTree(['/auth/update-password']);
  }

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  if (!auth.isConsoleAdmin()) {
    await auth.clearSession();
    return router.createUrlTree(['/auth/login']);
  }

  return true;
};
